import type {ReactNode} from 'react';
import {BlockStack} from '@shopify/polaris';

import {FilterItem} from './components';
import styles from './FilterList.scss';

interface FilterListProps {
  children: ReactNode;
}

export function FilterList({children}: FilterListProps) {
  return (
    <ul className={styles.FilterList}>
      <BlockStack gap="300">{children}</BlockStack>
    </ul>
  );
}

FilterList.Item = FilterItem;
